import styled from "styled-components";

export const ClockIconWrapper = styled.div`
  position: relative;
  top: 5px;
  color: var(--section-slate-color, var(--slate));
`;
